import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FacebookService, UIParams, UIResponse } from 'ngx-facebook';
import { DayjsPipe } from '../../../../shared/pipes/dayjs/dayjs.pipe';
import { EventsService, FbService, ShareMessagesService, UtilService, VariablesService } from '../../../../shared/services';

@Component({
  selector: 'app-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.scss'],
  providers: [DayjsPipe]
})
export class WidgetComponent implements OnInit {

  constructor(
    public utilService: UtilService,
    private event: EventsService,
    public fbService: FbService,
    public shareMessagesService: ShareMessagesService,
    private dayjsPipe: DayjsPipe,
    private variableService: VariablesService,
    private fb: FacebookService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog
  ) { }

  @Input('widgetData') campaign: any;
  @Input('currencyIcon') currencyIcon;
  @Input('currency') currency: string;
  @Input('origin') origin = 'default';
  @Input() amount = true;
  @Input() utmTags;
  @Input() openInNewTab;
  @Input() scrollToTop;
  @Input() supporters = true;
  @Input() showShareBtn = false;
  @Input() config;
  @Input() isSuccessStory = false;
  @Input() hideRaised;
  @Input() redirect = true;
  isLoading;
  basicinfo;
  isMobile;

  utmData = {
    source: 'internal',
    medium: 'fbpageshare',
    campaign_name: ''
  };

  ngOnInit() {
    this.isMobile = this.utilService?.isMobile();
    if (this.showShareBtn) {
      /**
       * basic info is set to update basic info in variable service which is used for whatsapp
       * fundraiser updated data is set because we need campaign id for fb share
       */
      this.variableService.fundraiser = this.campaign;
      this.basicinfo = this.utilService.setBasicInfo(this.campaign.basic_info, false);
      if (this.basicinfo?.basicInfo && 'basicInfo' in this.basicinfo) {
        this.variableService.basicInfo = { ...this.basicinfo.basicInfo };
      }
    }
  }

  /** Go to the url of the campaign
   *  based on domain
   */
  goToCampaign(event, page, isDonate?): void {
    if (!this.redirect) {
      return;
    }
    if (this.isSuccessStory) {
      return ;
    }
    this.clickEvent();
    if (this.config && this.config.sysEventOnClick) {
      const sysEvent = {
        eventName: 'product_clicked',
        pageName: this.variableService.pageName,
      };
      this.sendSystemEvent(sysEvent);
    }
    event.stopPropagation();
    const origin = page === 'stories' ? 'stories' : 'fundraiser';
    const donatePopup = isDonate ? '?donate=true' : '';
    if (donatePopup) {
      const payload = {
        eventName: 'Contribution Initiated',
        event_type: 'campaign',
        page_name: this.variableService.pageName,
        info_1: 'position',
        info_2: 14,
        info_3: 'campaign',
        event_type_id: this.campaign.id
      };
      this.sendSystemEvent(payload);
    }
    if (this.openInNewTab) {
      this.utilService.nativeNavigation(`/${origin}/${this.campaign?.custom_tag?.trim()}${donatePopup}`, true);
    } else {
      this.dialog.closeAll();
      setTimeout(() => {
        this.utilService.scrollToTop();
      }, 500);
      if (isDonate) {
        this.utilService.router.navigate([`/${origin}`, this.campaign?.custom_tag?.trim()], { queryParams: { donate: true } });
      } else {
        this.utilService.router.navigate([`/${origin}`, this.campaign?.custom_tag?.trim()]);
      }
    }
    if (this.scrollToTop) {
      this.utilService.scrollToTop();
    }
  }

  sendSystemEvent(payload) {
    this.event.sendSystemEvent(payload).subscribe(_ => { });
  }

  /** Call this function when a user clicks on a product link.
   * This function uses the event callback datalayer variable to handle
   * navigation after the ecommerce data has been sent to Google Analytics. */
  clickEvent() {
    const clickEvent = {
      'event': 'productClick',
      'ecommerce': {
        'click': {
          'actionField': { 'list': 'Trending Fundraisers' },
          'products': [{
            'name': this.campaign.custom_tag, // Campaign Name
            'id': this.campaign.id, // Campaign ID.
            'category': this.utilService.getCampaignTypeFromId(this.campaign.parent_cause_id),  // Campaign Type
            'variant': this.campaign.cause_id,
            'position': 1,     // Position of the product in the list
            'dimension5': '', // cd_Fundraiser Attributes
            'dimension7': this.campaign.cause_id, // cd_Campaign Cause ID
            'dimension8': this.campaign.custom_tag, // cd_Campaign Custom Tag
            'dimension 9': this.campaign.id, // cd_Campaign ID
            'dimension10': this.utilService.getCampaignTypeFromId(this.campaign.parent_cause_id) // cd_Campaign Type
          }]
        }
      },
    };
    this.event.gtmPush(clickEvent);
  }

  async shareWhatsapp(event) {
    event.stopPropagation();
    let url;
    const isFundraiserEnded = this.dayjsPipe.transform(this.campaign.end_date, 'diffInDays') < 0;
    const message = await this.shareMessagesService.getWhatsAppMessage(this.campaign, this.basicinfo?.basicInfo, isFundraiserEnded);
    const whatsAppDomain = this.utilService.isMobile() ? 'api' : 'web';
    url = `https://${whatsAppDomain}.whatsapp.com/send?text=${message}`;
    this.shareMessagesService.shareEvents('whatsapp share', 1);
    window.open(url, '_blank');
  }


  async shareFB(event, campaignObj) {
    event.stopPropagation();
    let url;
    this.isLoading = await this.fbService.scriptLoaderFB();
    this.cdr.detectChanges();
    this.shareMessagesService.shareEvents('fb share', 1);
    const message = '';
    let pageName = 'fundraiser';
    if (campaignObj.support_campaign) {
      pageName = 'supportfundraiser';
    }
    const page = this.campaign.page_name === 'stories' ? 'stories' : pageName;
    url = `${this.utilService.domain_details.domain_url}/${page}/${campaignObj.custom_tag}`;
    this.utmData.campaign_name = campaignObj.custom_tag;


    const params: UIParams = {
      href: `${this.shareMessagesService.getLinkWithUtmTags(url, this.utmData)}`,
      method: 'share',
      message: message || ''
    };
    this.fb.ui(params).then((res: UIResponse) => { }).catch((e: any) => { });
  }

}
